import { render } from "./ReceiptCreate.vue?vue&type=template&id=f712a878&scoped=true"
import script from "./ReceiptCreate.vue?vue&type=script&lang=js"
export * from "./ReceiptCreate.vue?vue&type=script&lang=js"

import "./ReceiptCreate.vue?vue&type=style&index=0&id=f712a878&scoped=true&lang=css"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f712a878"]])

export default __exports__